/**
 * Network configuration.
 *
 * See {@link LightconeEnv} for environment-specific URLs and program IDs.
 */

export { LightconeEnv } from "./env";
